/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';
import { Icon } from '@fieldnation/platform-components';
import css from './WorkSummaryWidget.scss';
import { SkillV4Props } from '../types.d';
import NumberofJobs from './NumberOfJobs';

export default function SkillV4({
  name,
  numJobs = 0,
  lastCompletion,
  marketplaceRating,
  myCompanyRating,
}: SkillV4Props): JSX.Element {
  return (
    <>
      <div className={css.SkillV4}>
        <div className={css.SkillV4LeftContent}>
          {' '}
          <div className={css.SkillSetName}>
            <span>{name}</span>
          </div>
          <div>
            <span className={marketplaceRating ? css.SKMarketplace : css.SKNoRating}>
              <Icon name="starSolid" size={16} />
              <div className={marketplaceRating ? css.SkillSetRatingText : css.SkillSetNonRatingText}>
                <span>{marketplaceRating ? marketplaceRating?.toFixed(1) : 'N/A'}</span>
              </div>
            </span>
            <span className={myCompanyRating ? css.SKMyCompany : css.SKNoRating}>
              <Icon name="starSolid" size={16} />
              <div className={myCompanyRating ? css.SkillSetRatingText : css.SkillSetNonRatingText}>
                <span>{myCompanyRating ? myCompanyRating?.toFixed(1) : 'N/A'}</span>
              </div>
            </span>
          </div>
          {lastCompletion && (
          <div>
            <span className={css.SkillSetLastCompletion}>{`Last completed ${lastCompletion}`}</span>
          </div>
          )}
        </div>
        <div className={css.SkillV4RightContent}>
          {numJobs && (
          <div className={css.SkillV4NumJobs}>
            <NumberofJobs numJobs={numJobs} />
          </div>
          )}
        </div>
      </div>
    </>
  );
}
